import React, { useState, useRef } from 'react';
import ProcessBar from '../ProgressBar/ProgressBar';
import axios from 'axios'
import { Spin, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { VideoUploadAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import { useNavigate } from 'react-router-dom';

const VideoUploadInput = ({ eventId }) => {
    const [error, setError] = useState(null);
    const [displayProgressBar, setDisplayProgressBar] = useState(false);
    const [fileSize, setFileSize] = useState(null);
    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false); // Track upload status
    const [isCompleted, setIsCompleted] = useState(false); // Track upload status
    const [loading, setLoading] = useState(false)
    const abortControllerRef = useRef(null); // Ref to store AbortController

    const dispatch = useDispatch();
    const navigate = useNavigate();


    // const uploadFileInChunks = async (file) => {
    //     setError(null);
    //     const chunkSize = 1 * 1024 * 1024 * 1024; // 1 GB chunks
    //     const totalChunks = Math.ceil(file.size / chunkSize);

    //     abortControllerRef.current = new AbortController(); // Create new AbortController instance

    //     for (let i = 0; i < totalChunks; i++) {
    //         const start = i * chunkSize;
    //         const end = Math.min(start + chunkSize, file.size);
    //         const chunk = file.slice(start, end);

    //         const formData = new FormData();
    //         formData.append('files', chunk, file.name);

    //         try {
    //             const response = await PrivateAxiosInstance.put(
    //                 URLs.EDIT_SESSION_URL.replace(':eventId', eventId),
    //                 formData,
    //                 {
    //                     headers: {
    //                         'Content-Type': 'multipart/form-data',
    //                     },
    //                     withCredentials: 'include',
    //                     signal: abortControllerRef.current.signal, // Attach the abort signal
    //                 }
    //             );

    //             if (response?.status === 200) {
    //                 const newProgress = Math.round(((i + 1) / totalChunks) * 100);
    //                 setDisplayProgressBar(true);
    //                 setIsUploading(true);
    //                 setUploadProgress(newProgress);

    //                 if (newProgress === 100) {
    //                     setDisplayProgressBar(false);
    //                     setIsCompleted(true);
    //                 }
    //             } else {
    //                 console.error(
    //                     `Error uploading chunk ${i + 1}: ${response.statusText}`
    //                 );
    //                 setError('Uploading Error');
    //                 break; // Stop uploading if there's an error
    //             }
    //         } catch (error) {
    //             if (axios.isCancel(error)) {
    //                 setError('Upload canceled by user.');
    //                 setIsUploading(false);
    //                 setIsCompleted(false);
    //                 break;
    //             } else {
    //                 console.error(`Error uploading chunk ${i + 1}:`, error);
    //                 setError('Uploading Error');
    //                 break; // Stop uploading if there's an error
    //             }
    //         }
    //     }

    //     setDisplayProgressBar(false);
    //     setIsUploading(false);
    //     setFile(null);
    // };

    const uploadFileInChunks = async (file) => {
        setLoading(true)
        setError(null);
        setIsUploading(true);
        const chunkSize = 1 * 1024 * 1024 * 1024; // 1 GB chunks
        // const chunkSize = 1 * 1024 * 1024 * 6; // 1 GB chunks
        const totalChunks = Math.ceil(file.size / chunkSize);

        abortControllerRef.current = new AbortController(); // Create new AbortController instance

        // Create a base name for the video without the extension
        const baseVideoName = file.name.replace(/\.[^/.]+$/, ''); // e.g., "fish"
        const fileExtension = file.name.split('.').pop(); // Get the original file extension, e.g., "mp4"

        for (let i = 0; i < totalChunks; i++) {
            const start = i * chunkSize;
            const end = Math.min(start + chunkSize, file.size);
            const chunk = file.slice(start, end);

            // Create a unique name for each chunk, formatted as "baseVideoName_partX.originalExtension"
            const chunkFileName = `${baseVideoName}_part${i + 1}.${fileExtension}`; // e.g., "fish_part1.mp4"

            const formData = new FormData();
            formData.append('files', chunk, chunkFileName); // Use the new chunk name

            try {
                const response = await VideoUploadAxiosInstance.put(
                    URLs.EDIT_SESSION_URL.replace(':eventId', eventId),
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        withCredentials: 'include',
                        signal: abortControllerRef.current.signal, // Attach the abort signal
                    }
                );

                if (response.status === 200) {
                    const newProgress = Math.round(((i + 1) / totalChunks) * 100);
                    setDisplayProgressBar(true);
                    // setIsUploading(true);
                    setUploadProgress(newProgress);
                    // console.log(`Chunk ${i + 1} uploaded successfully `);
                    if (newProgress === 100) {
                        setDisplayProgressBar(false);
                        setIsCompleted(true);
                        message.success("File uploaded successfully");
                        navigate('/admin/session/all')
                    }
                } else {
                    console.error(
                        `Error uploading chunk ${i + 1}: ${response.statusText}`
                    );
                    setError('Uploading Error');
                    break; // Stop uploading if there's an error
                }
            } catch (error) {
                if (axios.isCancel(error)) {
                    setError('Upload canceled by user. refresh page');
                    setIsUploading(false);
                    setIsCompleted(false);
                    break;
                } else {
                    console.error(`Error uploading chunk ${i + 1}:`, error);
                    setError('Uploading Error');
                    break; // Stop uploading if there's an error
                }
            } finally {
                setLoading(false)
                setDisplayProgressBar(false);
                setIsUploading(false);
                setFile(null);
                setLoading(false)
                setFileName('');
                setFileSize(null);
                setFile(null)
            }
        }

        // setDisplayProgressBar(false);
        // setIsUploading(false);
        // setFile(null);
        // setLoading(false)

        setDisplayProgressBar(false);
        setIsUploading(false);
        setFile(null);
        setLoading(false)
        setFileName('');
        setFileSize(null);
        setFile(null)
    };

    const handleFileChange = (event) => {
        setError('')
        const file = event.target.files[0];
        console.log(file)
        const fileSizeMB = file?.size / 1024 / 1024;
        const fileSizeGB = file?.size / 1024 / 1024 / 1024;
        setFileSize(fileSizeGB > 1 ? `${fileSizeGB.toFixed(2)} GB` : `${fileSizeMB.toFixed(2)} MB`);
        setFileName(file.name);

        if (file) {
            const validTypes = ['video/mp4', 'video/x-m4v', 'video/*'];
            if (!validTypes.includes(file.type)) {
                setError('Invalid file type');
                event.target.value = null; // Clear the input
                return;
            } else {
                setError(null); // Clear error message if file is valid
            }
        }

        setFile(file);
    };

    const unSelectFile = () => {
        setError(null)
        setFileName('');
        setFileSize(null);
        setFile(null);
        setUploadProgress(0);
        setDisplayProgressBar(false);
        setIsUploading(false)
        setIsCompleted(false)
    };

    const handleUploadClick = () => {
        if (file) {
            uploadFileInChunks(file);
        } else {
            console.error('No file selected for upload.');
            setError('No file selected for upload.');
            setIsCompleted(false)
        }
    };

    const handleCancelUpload = () => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort(); // Abort the upload
            setError('Upload canceled.');
            setDisplayProgressBar(false);
            setIsUploading(false);
            setIsCompleted(false)
            setFileName('');
            setFileSize(null);
            setFile(null);
        }
    };

    return (
        <>
            <div className="w-full grid gap-5">



                <div className="w-full py-9 bg-gray-50 rounded-2xl border border-gray-300 border-dashed">
                    <div className="grid gap-3">
                        <svg className="mx-auto" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {/* SVG Content */}
                        </svg>
                        <div className="grid gap-1">
                            <h4 className="text-center text-gray-900 text-sm font-medium leading-snug">Drag an image here</h4>
                            <span className="text-center text-gray-400 text-xs font-light leading-4">OR</span>
                            <div className="flex items-center justify-center">
                                <label>
                                    <input
                                        type="file"
                                        name="files"
                                        accept="video/*"
                                        onChange={handleFileChange}
                                        hidden
                                    />
                                    <div className="flex w-28 h-9 px-2 flex-col bg-indigo-600 rounded-full shadow text-white text-xs font-semibold leading-4 items-center justify-center cursor-pointer focus:outline-none">Choose File</div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full grid gap-4">
                    <div className="w-full grid gap-1">
                        {fileName && !error && (
                            <div className="w-full grid gap-1">
                                <div className="flex items-center justify-between gap-2">
                                    <div className="flex items-center gap-2">

                                        <svg width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.58487 19L7.07189 15.2455C7.69252 14.4869 8.00284 14.1076 8.40938 14.0633C8.47386 14.0563 8.53887 14.0555 8.60349 14.0611C9.01094 14.0961 9.32986 14.4682 9.9677 15.2123C10.6306 15.9857 10.962 16.3723 11.381 16.4005C11.4473 16.4049 11.5139 16.4027 11.5797 16.394C11.996 16.3387 12.3016 15.9312 12.9127 15.1164L14.3606 13.1858C15.11 12.1867 15.4847 11.6871 15.9919 11.693C16.4992 11.6989 16.8622 12.207 17.5881 13.2233L21 18M21 18V11C21 7.22876 21 5.34315 19.8284 4.17157C18.6569 3 16.7712 3 13 3H11C7.22876 3 5.34315 3 4.17157 4.17157C3 5.34315 3 7.22876 3 11V13C3 16.7712 3 18.6569 4.17157 19.8284C5.34315 21 7.22876 21 11 21H18C19.6569 21 21 19.6569 21 18Z" stroke="#4F46E5" stroke-width="1.7" class="my-path"></path>
                                            <path d="M12 9C12 10.1046 11.1046 11 10 11C8.89543 11 8 10.1046 8 9C8 7.89543 8.89543 7 10 7C11.1046 7 12 7.89543 12 9Z" stroke="#000000" stroke-width="1.7" class="my-path"></path>
                                        </svg>

                                        <div className="grid gap-1">
                                            <h4 className="text-gray-400 text-sm font-normal leading-snug">{fileName}</h4>
                                            <h5 className="text-gray-400 text-xs font-normal leading-4">{fileSize}</h5>
                                        </div>
                                    </div>

                                    <svg onClick={unSelectFile} className='cursor-pointer' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <g id="Upload 3">
                                            <path id="icon" d="M15 9L12 12M12 12L9 15M12 12L9 9M12 12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#D1D5DB" stroke-width="1.6" stroke-linecap="round" />
                                        </g>
                                    </svg>

                                </div>
                            </div>
                        )}

                        {error &&
                            <span className="text-red-500 text-sm h-5 block">
                                {error || <>&nbsp;</>}
                            </span>
                        }

                        {displayProgressBar &&
                            <ProcessBar progress={uploadProgress} />
                        }

                        {isCompleted &&
                            <span className="text-green-500 text-sm h-4 block">
                                Successfully uploaded
                            </span>
                        }

                        {isUploading &&
                            <span className="text-green-500 text-sm h-4 block">
                                Video is uploading. it take time......
                            </span>
                        }
                    </div>

                    {/* Upload and Cancel buttons */}
                    {!isUploading ? (
                        <button
                            onClick={handleUploadClick} // Change this to handleUploadClick
                            className="font-poppins w-[150px] text-white bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Update Video
                        </button>
                    ) : (
                        <button
                            onClick={handleCancelUpload} // Change this to handleUploadClick
                            className="font-poppins w-[150px] text-white bg-gray-500 transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Cancel Upload
                        </button>
                    )}

                </div>
            </div>
        </>
    );
};

export default VideoUploadInput;
